import React, { useState } from 'react';

interface TooltipProps {
  content: string;
  children: React.ReactNode;
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({ content, children, className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className={`relative inline-flex items-center ${className}`}>
      {children}
      <div 
        className="ml-2 inline-flex items-center justify-center w-4 h-4 bg-gray-600 text-white text-xs rounded-full cursor-help hover:bg-gray-500 transition-colors"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        ?
      </div>
      {isVisible && (
        <div className="absolute z-50 bottom-full left-0 mb-2">
          <div className="bg-gray-900 text-white text-sm rounded-lg px-4 py-3 w-80 shadow-lg border border-gray-700">
            <div className="text-left leading-relaxed">
              {content}
            </div>
          </div>
          {/* Arrow */}
          <div className="absolute top-full left-6 transform -translate-x-1/2">
            <div className="border-4 border-transparent border-t-gray-900"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip; 